<template>
  <div class="card-body">
    <h4 id="header-channel" class="card-title card-collapse ">
      <span
        class="pointer"
        @click="
          channelComponentModel.collapseState = !channelComponentModel.collapseState
        "
        >Channel</span
      >
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="channelComponentModel.validateState == false"
          @click="
            channelComponentModel.collapseState = !channelComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            channelComponentModel.collapseState = !channelComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="channelComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-channel"
      v-model="channelComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <div class="pt-3">
          <div class="row">
            <div class="col-12">
              <div class="border-top pb-4"></div>
              <table-select-channel
                v-model="channelComponentModel.model"
                :isDisabled="
                  dataPermissions.find(f => f.name === 'channels')
                    .isEditable === false
                "
                :business_unit="business_unit"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12"></div>
          </div>
        </div>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import TableSelectChannel from '@/components/product-register/table-select-channel'
import { eventBus } from '@/main.js'
export default {
  name: 'Channel',
  components: { 'table-select-channel': TableSelectChannel },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.channelComponentModel
      },
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    business_unit : {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      channelComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: [],
      },
      permissions: [
        {
          name: 'channels',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
    }
  },
  created() {
    eventBus.$on('collapse-channel', text => {
      this.channelComponentModel.collapseState = true
      this.onSubmit()
    })
  },
  mounted() {
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
  },
  watch: {
    //     value: {
    //       handler(val) {
    // //ไม่ต้องใช้เพราะใช้ในส่วน this.onGetCatalogAsync() แล้ว ให้ Checkbox ตาม value
    //       },
    //       deep: true,
    //     },
    value: {
      handler(val) {
        this.channelComponentModel = val
        this.$nextTick(() => {
          this.onSubmit()
        })
      },
      deep: true,
    },
    'channelComponentModel.model': {
      handler(val) {
        this.onSubmit()
      },
      deep: true,
    },
  },
  methods: {
    modelChanged() {
      this.channelComponentModel.isPayloadChanged = true
      this.$emit('input', this.channelComponentModel)
    },
    onSubmit() {
      this.$refs.componentForm.validate().then(result => {
        if (result && this.channelComponentModel.model.length > 0) {
          this.channelComponentModel.validateState = true
        } else {
          this.channelComponentModel.validateState = false
        }
        this.modelChanged()
      })
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
  },
}
</script>
